var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.info
    ? _c(
        "div",
        {
          staticClass: "commmmission-tab-root",
          class: [_vm.$i18n.locale === "ar" ? "ar-style" : "", _vm.packageName],
        },
        [
          _c("div", { staticClass: "card-block" }, [
            _c(
              "div",
              {
                staticClass: "tit-tips right-read",
                attrs: { id: "invite-target-dd" },
              },
              [
                _c("div", { staticClass: "block-title" }, [
                  _vm._v(" " + _vm._s(_vm.$t("lang.newInvite.k012")) + " "),
                  _c("img", {
                    attrs: { src: require("../images/rules-tips2.png") },
                    on: { click: _vm.toRules },
                  }),
                ]),
                _c("div", { staticClass: "beans-got" }, [
                  _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
                  _vm._v(" " + _vm._s(_vm.info.weekAgentCommissionBeans) + " "),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "percent-bar", attrs: { id: "invite-target-cc" } },
              [
                _c("PercentBar", {
                  attrs: {
                    percentCount: _vm.info.weekHostEarningBeans,
                    earnTypeList: _vm.info.commissionLevelList,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "vlolation-deduction right-read",
                on: { click: _vm.toViolationDetails },
              },
              [
                _vm._v(" " + _vm._s(_vm.$t("lang.newInvite.k013")) + " "),
                _c("div", [
                  _c("img", {
                    staticClass: "beans-icon",
                    attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                  }),
                  _c("span", [
                    _vm._v(_vm._s(_vm.info.weekHostDeductionBeans || 0)),
                  ]),
                  _c("img", {
                    staticClass: "arrow-icon ar-arrow",
                    attrs: { src: require("../images/arrow-r.png"), alt: "" },
                  }),
                ]),
              ]
            ),
          ]),
          _c(
            "div",
            { staticClass: "card-block pd-gap" },
            [
              _c("div", { staticClass: "block-title" }, [
                _vm._v(_vm._s(_vm.$t("lang.newInvite.k014"))),
              ]),
              _c("div", { staticClass: "deliver-line" }),
              _c("div", { staticClass: "list-fields right-read" }, [
                _c("div", { staticClass: "field field1" }, [
                  _vm._v(_vm._s(_vm.$t("lang.wd.phAccount"))),
                ]),
                _c("div", { staticClass: "field field2" }, [
                  _vm._v(" " + _vm._s(_vm.$t("lang.dl.income")) + " "),
                  _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
                ]),
                _c("div", { staticClass: "field field3" }, [
                  _vm._v(" " + _vm._s(_vm.$t("lang.dl.commission")) + " "),
                  _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
                ]),
              ]),
              _vm._l(_vm.weekData.hostIncomes, function (item, index) {
                return _c(
                  "div",
                  { key: item.index, staticClass: "list-fields right-read" },
                  [
                    _c("div", { staticClass: "bd-field field1 user-info" }, [
                      _c("div", { staticClass: "list-rank" }, [
                        index == 0
                          ? _c("div", { staticClass: "num first" }, [
                              _vm._v("1"),
                            ])
                          : index == 1
                          ? _c("div", { staticClass: "num second" }, [
                              _vm._v("2"),
                            ])
                          : index == 2
                          ? _c("div", { staticClass: "num third" }, [
                              _vm._v("3"),
                            ])
                          : _c("div", { staticClass: "num normal" }, [
                              _vm._v(_vm._s(index + 1)),
                            ]),
                      ]),
                      _c("div", { staticClass: "name-id" }, [
                        _c("div", { staticClass: "name-wrap" }, [
                          _c("span", [_vm._v(_vm._s(item.nickname))]),
                          _c("img", {
                            attrs: {
                              src: _vm._f("imgPath")(item.locationFlag),
                            },
                          }),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "id-wrap",
                            on: {
                              click: function ($event) {
                                _vm.handleCopy(
                                  item.presentId,
                                  _vm.$t("lang.msgCopySuccss")
                                )
                              },
                            },
                          },
                          [
                            _vm._v(" ID:" + _vm._s(item.presentId) + " "),
                            _c("img", {
                              attrs: {
                                src: require("../images/copy-gray.png"),
                                alt: "",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "bd-field field2" }, [
                      _vm._v(_vm._s(item.hostIncome)),
                    ]),
                    _c("div", { staticClass: "bd-field field3" }, [
                      _vm._v(_vm._s(item.hostIncomeCommission)),
                    ]),
                  ]
                )
              }),
              _c(
                "div",
                {
                  staticClass: "more-performance right-read",
                  on: { click: _vm.toPerformance },
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.$t("lang.newInvite.k048")))]),
                  _c("img", {
                    staticClass: "ar-arrow",
                    attrs: { src: require("../images/arrow-r.png"), alt: "" },
                  }),
                ]
              ),
            ],
            2
          ),
          _c("div", { staticStyle: { height: "450px" } }),
          _c(
            "div",
            {
              staticClass: "newguy-guide",
              attrs: { id: "guide-step5" },
              on: {
                click: function ($event) {
                  return _vm.handleGuideClick(5)
                },
              },
            },
            [
              _c("div", { staticClass: "step4" }, [
                _c("div", { staticClass: "btn-wrap" }, [
                  _c("div", { staticClass: "newguy-guide-btn" }, [
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.handleGuideClick(5)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("lang.ok")))]
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "card-block" }, [
                  _c(
                    "div",
                    {
                      staticClass: "tit-tips",
                      attrs: { id: "invite-guide-dd" },
                    },
                    [
                      _c("div", { staticClass: "block-title right-read" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("lang.newInvite.k012")) + " "
                        ),
                        _c("img", {
                          attrs: { src: require("../images/rules-tips2.png") },
                        }),
                      ]),
                      _c("div", { staticClass: "beans-got" }, [
                        _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
                        _vm._v(" 500 "),
                      ]),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "newguy-guide-tips" }, [
                  _c("div", { staticClass: "tips-content" }, [
                    _c(
                      "div",
                      { staticClass: "tips-title right-align right-read" },
                      [_vm._v(_vm._s(_vm.$t("lang.newInvite.k047")))]
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "newguy-guide",
              attrs: { id: "guide-step4" },
              on: {
                click: function ($event) {
                  return _vm.handleGuideClick(4)
                },
              },
            },
            [
              _c("div", { staticClass: "step5" }, [
                _c("div", { staticClass: "btn-wrap" }, [
                  _c("div", { staticClass: "newguy-guide-btn" }, [
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.handleGuideClick(4)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("lang.newInvite.k050")))]
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "newguy-guide-percent",
                    attrs: { id: "invite-guide-cc" },
                  },
                  [
                    _c("PercentBar", {
                      attrs: {
                        percentCount: 10000,
                        earnTypeList: [
                          {
                            minBeans: 0,
                            levelRate: 5,
                          },
                          {
                            minBeans: 100000,
                            levelRate: 8,
                          },
                          {
                            minBeans: 100000,
                            levelRate: 8,
                          },
                          {
                            minBeans: 10000000,
                            levelRate: 20,
                          },
                        ],
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "newguy-guide-tips" }, [
                  _c("div", { staticClass: "tips-content" }, [
                    _c(
                      "p",
                      { staticClass: "tips-title right-read right-align" },
                      [_vm._v(_vm._s(_vm.$t("lang.newInvite.k045")))]
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }